export default "/images/a94aeb37f08eda2dafee48ee8e4eedf6.avif";